module.exports = __webpack_public_path__ + "img/tabler_sort-descending.ef5b959a.svg";